export const savedWordFields = {
  title_operand: "titleOperand",
  title_values: "titleValues",
  mapping: "mapValues",
  logic_operand: "logicOperands",
  job_level_values: "job_level",
  job_area_values: "job_area",
  custom_level_values: "custom_level",
};

export const additionalFields = {
  job_level: {
    text_color: "ACJobLevel.contrastText",
    background_color: "ACJobLevel.light",
  },
  job_area: {
    text_color: "ACJobArea.contrastText",
    background_color: "ACJobArea.light",
  },
  custom_level: {
    text_color: "ACCustomLevel.contrastText",
    background_color: "ACCustomLevel.light",
  },
};

export const operands = {
  title_operands: {
    is: "equals to",
    in: "contains",
  },
  or: "or",
  and: "and",
};

export const llmChatMessages = {
  formal: {
    greetings: [
      "Glad you’re here! My job? Make keyword rule-building effortless. Start by typing your requirements!",
      "Need help translating human-friendly requirements into keyword rules? You've come to the right bot!",
      "Let’s talk logic. Just send in your requirements, and I’ll suggest smart keyword rules.",
      "Let’s build your keyword rules! Paste your requirements and I’ll take it from there.",
      "Welcome! Drop your list requirements and I’ll help you create precise keyword rules.",
    ],
    loading: [
      "Processing your requirements. Please wait...",
      "Generating results — almost there...",
      "Analyzing linguistic patterns and constructing logical rules...",
      "Consulting internal logic engine...",
      "Processing your requirements. Please wait...",
    ],
    complete: [
      "Transformation complete. Please review the result and finalize the mappings.",
      "All set. You're welcome to refine or submit more requirements.",
      "Initial pass complete. You may apply additional refinements.",
      "Keyword rules generated successfully. Proceed with verification.",
      "Conversion successful. Ready to assist with further inputs.",
    ],
  },
  fun: {
    greetings: [
      "Hey hey! I turn your chaos into rules perfection. Let’s cook 🧑‍🍳",
      "List too long? Brain tired? Let me do the thinking — I’m 100% silicon-powered 🧠",
      "Your keyword therapist has arrived. Tell me what’s bothering your list 👂",
      "Drop your requirements. I’ll drop the 🔥 rules. Deal?",
      "Yo! Give me requirements → get back logic. Like ChatGPT… but rule-ified.",
    ],
    loading: [
      "Currently cooking: Logic. Smells like a clean rule set 👨‍🍳",
      "Almost done — just beating your requirements in a logic duel 🥊",
      "Engaging hamster wheel of logic… 🐹🔄",
      "Summoning rule gods. Sacrificing typos 🕯️📜",
      "Compiling the rules faster than you can say “regex” 🧠",
    ],
    complete: [
      "That moment when requirements become reality 💡",
      "Boom 💥 Got rules. Now go rule the world.",
      "And just like that, logic has been served 🍽️",
      "If logic were an art — I just Picasso’d it 🎨",
      "Your logic smoothie is ready. Add toppings (a.k.a. mappings) if needed 🥤",
    ],
  },
  game: {
    greetings: [
      "🧙 Welcome, wizard! Cast your requirements spell, and I’ll reveal the rule scrolls.",
      "👾 Boss fight unlocked: “Ambiguous Requirements”. Equip me to win.",
      "🎮 Tutorial started: 'Transform requirements into rules' — send Requirements to begin.",
      "💬 RuleBot.exe initialized. Ready to parse, predict, and punch messy logic.",
      "📜 Input requirements. Unlock: Legendary Keyword Rule ✨",
    ],
    loading: [
      "🎯 Charging keyword cannon... ",
      "🏗️ Constructing logic fortress — watch your head!",
      "🧩 Solving the puzzle of your request...",
      "💎 Crafting legendary logic gear...",
      "👾 Entering Rule Dungeon: Boss = Fuzzy Wording",
    ],
    complete: [
      "🎮 Level passed. Ready for the next challenge?",
      "🗂️ Rule Codex updated. Validate for legendary status.",
      "⚙️ Mechanism activated. Prepare next sequence when ready.",
      "🔓 Puzzle solved! Time to lock in your final moves.",
      "🧪 Transmutation successful. Mappings await your touch.",
    ],
  },
};
